const getters = {
  getVisibilityState: state => state.visibilityState,
}

export default getters
